/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES clipping 料金システム用 API
 * PR TIMES clipping 料金システムで使うAPI。
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    GetIsApplyingSportTimesProgramResponseData,
    GetIsApplyingSportTimesProgramResponseDataFromJSON,
    GetIsApplyingSportTimesProgramResponseDataFromJSONTyped,
    GetIsApplyingSportTimesProgramResponseDataToJSON,
} from './GetIsApplyingSportTimesProgramResponseData';

/**
 * 
 * @export
 * @interface GetIsApplyingSportTimesProgramResponse
 */
export interface GetIsApplyingSportTimesProgramResponse {
    /**
     * 
     * @type {number}
     * @memberof GetIsApplyingSportTimesProgramResponse
     */
    status: number;
    /**
     * 
     * @type {string}
     * @memberof GetIsApplyingSportTimesProgramResponse
     */
    message: string;
    /**
     * 
     * @type {GetIsApplyingSportTimesProgramResponseData}
     * @memberof GetIsApplyingSportTimesProgramResponse
     */
    data: GetIsApplyingSportTimesProgramResponseData;
}

export function GetIsApplyingSportTimesProgramResponseFromJSON(json: any): GetIsApplyingSportTimesProgramResponse {
    return GetIsApplyingSportTimesProgramResponseFromJSONTyped(json, false);
}

export function GetIsApplyingSportTimesProgramResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetIsApplyingSportTimesProgramResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': GetIsApplyingSportTimesProgramResponseDataFromJSON(json['data']),
    };
}

export function GetIsApplyingSportTimesProgramResponseToJSON(value?: GetIsApplyingSportTimesProgramResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': GetIsApplyingSportTimesProgramResponseDataToJSON(value.data),
    };
}

